const dictionary = {
    en: {
      messages: { alpha_spaces: n => 'Field ' + n + ' may only contain alphabetic characters as well as spaces.' }
    },
    ru: {
      messages: { alpha_spaces: n => 'Поле ' + n + ' может содержать только буквенные символы и пробелы.' }
    },
    ja: {
      messages: { alpha_spaces: n => 'Field ' + n + ' may only contain alphabetic characters as well as spaces.' }
    }
  }
  
  const validator = {
    getMessage: field => 'Field ' + field + ' may only contain alphabetic characters as well as spaces.',
    /* eslint-disable */
    validate: value => /^(([A-Za-zА-Яа-яЁё\s])|([一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]))*$/.test(value.trim())
    /* eslint-enable */
  }
  
  export default { dictionary, validator }  